export enum JobStatusEnum {
    "Pending" = 1,
    "InProgress" = 2,
    "Completed" = 3,
    "Cancelled" = 4,
    "InActive" = 5,
    "Active" = 6,
    "Approved" = 7,
    "Flagged" = 8,
    "Deleted" = 9,
    "Contracted" = 10,
  }
  